import { mapProps, compose, withHandlers, withStateHandlers } from 'recompose';
import _ from 'lodash';
import { connect } from 'react-redux';
import StopStatusLogStage from './component';

import { isStageClickable } from 'redux/modules/journeys/stop-status-log';
import { isStageAdvancing, isStageOpened } from 'redux/modules/journey-stops/selectors';
import { setStageOpened, setStageClosed } from 'redux/modules/journey-stops/effects';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const journeyFields = ['driver', 'stops'];

const stopFields = [
  'score',
  'stop_type',
  'status',
  'time_to',
  'delayed_datetime',
  'shipment_state_logs',
  'problems',
];

const omitProps = (keys) => mapProps((props) => _.omit(props, keys));

const enhance = compose(
  withJourneyCardSelectors,
  connect(
    (state, props) => {
      const { stage, selectors, journeyId, stopId } = props;

      const stop = selectors.getJourneyStopFields(state, journeyId, stopId, stopFields);

      const stopsSource = selectors.getJourneyFields(state, journeyId, journeyFields);

      const { stops = [] } = stopsSource || {};

      const { score } = stop || {};

      const isClickable = isStageClickable(stage, { stopId, score, stops });

      const debugWarningOnTop = ((state.me || {}).groups || []).includes('ProdTech');

      return {
        isClickable,
        isLoading: isStageAdvancing(state, journeyId, stopId, stage),
        isOpened: isStageOpened(state, journeyId, stopId, stage),
        debugWarningOnTop,
      };
    },
    { setStageOpened, setStageClosed }
  ),
  omitProps(['stop', 'stops']),
  withStateHandlers(
    () => ({
      isOver: false,
    }),
    {
      setOver: () => (isOver) => ({
        isOver,
      }),
    }
  ),
  withHandlers(({ setStageClosed, journeyId, setOver }) => {
    let parentRef = null;

    function onOutsideClick(e) {
      if (!parentRef || parentRef.contains(e.target)) {
        return;
      }

      setStageClosed({ journeyId });
      setOver(false);

      document.removeEventListener('mousedown', onOutsideClick, false);
    }

    return {
      addDocumentListeners: () => () => {
        document.addEventListener('mousedown', onOutsideClick, false);
      },
      setParentRef: () => (ref) => {
        parentRef = ref;
      },
    };
  }),
  withHandlers(() => ({
    handleClick:
      ({ setStageOpened, journeyId, stage, stopId, isClickable, isOpened, addDocumentListeners }) =>
      (e) => {
        if (isOpened) {
          return;
        }

        if (!isClickable) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        setStageOpened({ journeyId, stage, stopId });
        addDocumentListeners();
      },
    handleMouseEnter:
      ({ setOver }) =>
      () => {
        setOver(true);
      },
    handleMouseLeave:
      ({ setOver }) =>
      () => {
        setOver(false);
      },
  }))
);

export default enhance(StopStatusLogStage);
